import { Component, Input, OnInit, OnDestroy, Output,EventEmitter,ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, LoadingController, MenuController, ModalController } from '@ionic/angular';
// import { Storage } from '@ionic/storage';
import { Storage } from '@ionic/storage-angular';
import { CartService } from 'src/app/services/cart.service';
import { DataService } from 'src/app/services/data.service';
import { IonInput, Platform  } from '@ionic/angular';

@Component({
  selector: 'app-price-detail',
  templateUrl: './price-detail.component.html',
  styleUrls: ['./price-detail.component.scss'],
})
export class PriceDetailComponent  implements OnInit, OnDestroy {

  // @Input() load;
  @Output() submit = new EventEmitter();
  @Output() close = new EventEmitter();
  @Input() selected_index;
  is_footer = true;
  expanded = false;
  // update
  @Input() product_detail;
  product_detail1;
  update_payload:any={};
  // subject_values;
  loader:any;
  null_stock_value = 0;
  focusIsSet!: boolean;
  @ViewChild('price', {static: false}) price!: IonInput;

  constructor(private platform: Platform,public modalCtrl: ModalController, public storage: Storage, public alertCtrl: AlertController, public ngcart: CartService, public db: DataService, private menuCtrl: MenuController, private loadingCtrl: LoadingController, private router: Router) {
  }

  ngOnInit() {
    console.log(this.product_detail);

    this.subscribe = this.db.price_submit.subscribe(res=>{
      console.log(res);
      if(res && res['status'] == 'price_updated'){
        delete res['status'];
        let value = JSON.stringify(res);
        this.product_detail1 = JSON.parse(value);
      }
    })

    // this.db.is_show = true;
    this.db.botton_name = this.db.botton_name ? this.db.botton_name : 'price'
    if(this.product_detail){
      let value = JSON.stringify(this.product_detail);
      this.product_detail1 = JSON.parse(value);
    }


    // this.db.add_price.subscribe((res:any)=>{
    //   console.log(res)
    //   if(res.message){
    //      this.selected_index = res.index
    //      let value = JSON.stringify(res.message);
    //      this.product_detail1 = JSON.parse(value);
    //      this.db.botton_name = 'price'
    //   }
 
    // })
  }

  subscribe:any;
  ngOnDestroy(): void {
    this.subscribe.unsubscribe();
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
  }

  public ngAfterViewChecked(): void {
    if (!this.focusIsSet && !this.db.ismobile) {
      this.price.setFocus();
      setTimeout(() => {this.focusIsSet = true; }, 1000);
    }
  }

  getPrice(event:any,variant:any,type:any){

    console.log(event);

    if(event.target.value){
      let value =  event.target.value;
      // value = value[0] == 0 ? value.substring(1) : value;
      value = Number(value);
      if(typeof(value) == 'string'){
        value = Number(value).toFixed(3);
      }else{
        value = value.toFixed(3);
      }
      type == 'old' ?  variant.old_price = value :  variant.price = value;
      console.log(variant)
    }else{
      type == 'old' ?  variant.old_price = 0.00 :  variant.price = 0.00;
    }
  }

  select_value(event:any){
      const inputElement = event.target.querySelector('input') as HTMLInputElement;
      inputElement.select();
  }

  closeDetail(){   
    if(this.db.ismobile){
      this.modalCtrl.dismiss();
    } else{
      this.close.emit(null)
    }
  }

  async save(data){
    if(this.product_detail1 && this.product_detail1.variants && this.product_detail1.variants.length != 0){
      let value = this.product_detail1.variants.find(res=>{
        if(res.old_price && res.old_price > 0){
          return (Number(res.price) > Number(res.old_price))
        }
      })

      // console.log(value);
      
      if(value){
        let obj = {alert:true,item:'Old Price must be greater than the Product Price',bg_color:this.db.alert_bg};
        this.db.alert_animate.next(obj);
        // this.db.ismobile ? this.db.auto_close_alert('Old Price must be greater than the Product Price') : this.db.alert_animate.next(obj);
      }else{
        this.update_prices_list()
        // this.save_prices(data)
      }

    }else{
      if(data.old_price && data.old_price > 0 && Number(data.price) > Number(data.old_price)){
        let obj = {alert:true,item:'Old Price must be greater than the Product Price',bg_color:this.db.alert_bg};
        this.db.alert_animate.next(obj);
        // this.db.ismobile ? this.db.auto_close_alert('Old Price must be greater than the Product Price') : this.db.alert_animate.next(obj);
      }else{
        let price = 0;
        let old_price = 0;

        if(data.price == this.product_detail.price){
          price = 1;
        }

        if(data.old_price == this.product_detail.old_price){
          old_price = 1;
        }

        if(price == 0 || old_price == 0){
          this.save_prices(data);
        }else{
          let obj = {alert:true,item:'No update found',bg_color:this.db.alert_bg};
          this.db.alert_animate.next(obj);
        }
        // this.save_prices(data);
      }
    } 
  }

  update_prices_list(){
    let array:any = []
    if(this.product_detail1 && this.product_detail1.variants && this.product_detail1.variants.length != 0){
      this.product_detail1.variants.map((res , i)=>{
        this.product_detail.variants.map(r=> {
          if(r.attribute_id == res.attribute_id){
             let price = 0;
             let old_price = 0;

              if(r.price == res.price){
                price = 1;
              }
              if(r.old_price == res.old_price){
                old_price = 1;
              }

              if(price == 0 || old_price == 0){
                array.push(res);
              }
          }
        });

        if(this.product_detail1.variants.length == (i + 1)){
          if(array.length == 0){
            let obj = {alert:true,item:'No update found',bg_color:this.db.alert_bg};
            this.db.alert_animate.next(obj);
          }else{
            this.product_detail1['updated_variants'] = array;
            this.save_prices(this.product_detail1)
          }
        }

      })
    }
  }

  save_prices(product_detail1){
    if(this.db.ismobile){
      // this.modalCtrl.dismiss(product_detail1);
      product_detail1.status = 'Success';
      product_detail1.selected_index = this.selected_index;
      this.db.price_submit.next(product_detail1);
    }else{
      product_detail1.selected_index = this.selected_index;
     this.submit.emit({'message':product_detail1,'index':this.selected_index})
    }
  }

  btn_change(type){
    console.log(type);
    if(type == 'edit'){
      console.log(this.db.edit_product_value);
      
      this.db.product_detail.next( this.db.edit_product_value);
    }else if(type == 'price'){
     
    }
    this.db.botton_name = type
  }
}
